import { useSelector } from 'react-redux';

import { isNil } from 'lodash-es';
import { useMemo } from 'react';
import type { RootReducerType } from '../redux/reducers/RootReducer.types';
import { getEnvironmentVariable } from '../utils/EnvironmentHelper';

interface PrelaunchStore {
  isPrelaunch: boolean;
  isBeta: boolean;
}

const usePrelaunch = (): PrelaunchStore => {
  const userProfile = useSelector(
    (state: RootReducerType) => state.user.profileResponse,
  );
  const currentAppConfig = useSelector(
    (state: RootReducerType) => state.config.appConfig,
  );

  const isPrelaunch = useMemo<boolean>(
    () =>
      isNil(currentAppConfig) ||
      (isNil(userProfile) &&
        !isNil(currentAppConfig) &&
        currentAppConfig.prelaunch &&
        (!isNil(getEnvironmentVariable('REACT_APP_IGNORE_BETA')) ||
          getEnvironmentVariable('REACT_APP_IGNORE_BETA') !== 'true')),
    [currentAppConfig, userProfile],
  );

  const isBeta =
    !isNil(getEnvironmentVariable('REACT_APP_FULL_MESSAGING')) &&
    getEnvironmentVariable('REACT_APP_FULL_MESSAGING') === 'true';

  return {
    isPrelaunch,
    isBeta,
  };
};

export default usePrelaunch;
